import { CastForEducation, MenuBook, School } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ThemedSvg } from "../../components/UIToolkit/ThemedSvg";
import { NurseTrainingStatus } from "../../utils/models";
import { NurseAgencyIndicator } from "../NurseAgencyIndicator/NurseAgencyIndicator";
import { NurseUnionIndicator } from "../NurseUnionIndicator/NurseUnionIndicator";

type NurseStatusIconsProps = {
	nurseId: number;
	charge?: boolean;
	trainingStatus?: NurseTrainingStatus;
};

export const NurseStatusIcons: FC<NurseStatusIconsProps> = ({ nurseId, charge, trainingStatus }) => {
	const { t } = useTranslation();
	return (
		<>
			<NurseUnionIndicator nurseIdOrNurseObject={nurseId} />
			<NurseAgencyIndicator nurseId={nurseId} />
			{charge && <ThemedSvg src="/charge.svg" alt="charge" size={16} color="var(--inhouse-primary)" />}
			{trainingStatus === NurseTrainingStatus.Trainee && (
				<Tooltip title={t("tooltip.nurse.trainee")}>
					<School aria-label={t("tooltip.nurse.trainee")} data-testid="nurse-status-trainee-icon" style={{ width: 12, height: 12 }} />
				</Tooltip>
			)}
			{trainingStatus === NurseTrainingStatus.Orientation && (
				<Tooltip title={t("tooltip.nurse.orientation")}>
					<MenuBook aria-label={t("tooltip.nurse.orientation")} data-testid="nurse-status-orientation-icon" sx={{ width: 12, height: 12 }} />
				</Tooltip>
			)}
			{trainingStatus === NurseTrainingStatus.Education && (
				<Tooltip title={t("tooltip.nurse.education")}>
					<CastForEducation aria-label={t("tooltip.nurse.education")} data-testid="nurse-status-education-icon" sx={{ width: 12, height: 12 }} />
				</Tooltip>
			)}
		</>
	);
};
